import React, { useState } from 'react'
import { ButtonGroup, Button } from '@mui/material'

const TabButtonGroup = ({ options, onSelect, defaultSelected }) => {
  const [selected, setSelected] = useState(defaultSelected || options[0]?.key)

  const handleSelect = (obj) => {
    setSelected(obj.title)
    onSelect(obj)
  }

  return (
    <ButtonGroup variant='contained' className='tabButtonGroup' aria-label='radio button group'>
      {options.map(({ key, title }, i) => {
        return (
          <Button
            key={key || title}
            onClick={() => handleSelect(options[i])}
            color={selected === (title || key) ? 'primary' : 'inherit'}
          >
            {title}
          </Button>
        )
      })}
    </ButtonGroup>
  )
}

export default TabButtonGroup
